import { getSupportedLocales } from 'configs';
import loadIntlData from 'i18n/intlDataConfig';
import loadLocaleData from 'i18n/localeDataConfig';

export function isSupportedLocale(locale) {
  return getSupportedLocales().includes(locale);
}

export function getDefaultLocale() {
  return getSupportedLocales()[0];
}

export function getLocale() {
  const browserLocale = navigator.language;
  console.log(`browser language: ${browserLocale}`);
  if (browserLocale && isSupportedLocale(browserLocale)) {
    console.log(`Using locale: ${browserLocale}`);
    return browserLocale;
  }

  // fallback to base locale if we have it
  if (browserLocale && browserLocale.indexOf('-') !== -1) {
    // en-US -> 'en' or 'de-DE' -> 'de'
    const baseLocale = browserLocale.split('-')[0];
    if (isSupportedLocale(baseLocale)) {
      console.log(`Using base locale: ${baseLocale}`);
      return baseLocale;
    }
  }

  const defaultLocale = getDefaultLocale();
  console.log(defaultLocale);
  return defaultLocale;
}

export function createLocalizeApp(renderApp, locale = getLocale()) {
  if (!window.Intl) {
    loadIntlData(locale, renderApp);
  } else {
    loadLocaleData(locale, renderApp);
  }
}



// WEBPACK FOOTER //
// ./src/i18n/i18nConfig.js